export enum CustomerFlow {
  Base = 'base',
  CarTrip = 'carTrip',
  FlightOnlyFromMarketplace = 'flightOnlyFromMarketplace',
  FlightHotelFromMarketplace = 'flightHotelFromMarketplace',
  HotelOnlyFromMarketplace = 'hotelOnlyFromMarketplace',
  ActivityOnlyFromMarketplace = 'activityOnlyFromMarketplace',
  InfiniteLoadReload = 'infiniteLoadReload',
  MetaHotel = 'metaHotel',
  HotelSelectionForCountryFromMarketplace = 'hotelSelectionForCountryFromMarketplace',
  HotelUpsell = 'hotelUpsell',
}
